export const nativeWebviewDebugger = (message, data = {}) => {
  const payload = {
    type: 'NATIVE_WEBVIEW_DEBUG',
    payload: {
      message,
      data
    }
  }
  if (window.ReactNativeWebView) {
    payload._windowType = 'nativeWebviewDebugger (React Native)'
    window.ReactNativeWebView.postMessage(JSON.stringify(payload))
  } else if (window.webkit) {
    payload._windowType = 'nativeWebviewDebugger (WebKit)'
    window.webkit.messageHandlers.nativeWebviewDebugger.postMessage(payload)
  } else if (window.JSInterface) {
    payload._windowType = 'nativeWebviewDebugger (Android)'
    window.JSInterface.postMessage(JSON.stringify(payload))
  }
}

export default function(ctx, inject) {
  const isWebView = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    // Detect iOS WebView
    const isIosWebView = !!window.webkit && !!window.webkit.messageHandlers
    // Detect Android WebView
    const isAndroidWebView =
      !!window.ReactNativeWebView ||
      /wv|Version\/[\d.]+.*Chrome\/[\d.]+ Mobile/.test(userAgent)
    return isIosWebView || isAndroidWebView
  }

  if (isWebView()) {
    console.log('Running inside WebView:', isWebView())
    // Store the original console.log
    const originalLog = console.log
    // Override console.log
    console.log = function(...args) {
      // Add your function BEFORE calling the original log
      nativeWebviewDebugger(args)
      // Call the original console.log so logs still appear in dev tools
      originalLog.apply(console, args)
    }
  }

  inject('nativeWebviewDebugger', nativeWebviewDebugger)
  ctx.$nativeWebviewDebugger = nativeWebviewDebugger
}
